import { render } from "./affected_to_club.vue?vue&type=template&id=659d6df4&ts=true"
import script from "./affected_to_club.vue?vue&type=script&lang=ts"
export * from "./affected_to_club.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__